import RequestAbstract from "./RequestAbstract";

export default class FileStorage extends RequestAbstract {
    get link() {
        return this.links.fileStorage;
    }

    getForClient(clientId, sortKey = "clientId") {

        const arr = [
            { field: "clientId", op: "=", value: clientId },
        ];

        return this.getAllFiltered([arr], this.getSortField(sortKey));
    }

    getPresentationClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "domain", op: "=", value: "presentation" },
        ];

        return this.getAllFiltered([arr]);
    }

    getAnalisisClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "domain", op: "=", value: "medical_tests" },
        ];

        return this.getAllFiltered([arr]);
    }


}
